var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCondo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "854.000000pt",
    height: "1024.000000pt",
    viewBox: "0 0 854.000000 1024.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1024.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5120 l0 -5120 4270 0 4270 0 0 5120 0 5120 -4270 0 -4270 0 0 -5120z m8110 0 l0 -4690 -1065 0 -1065 0 0 1065 0 1065 -1710 0 -1710 0 0 -1065 0 -1065 -1065 0 -1065 0 0 4690 0 4690 3840 0 3840 0 0 -4690z m-4050 -3840 l0 -850 -535 0 -535 0 0 850 0 850 535 0 535 0 0 -850z m1490 0 l0 -850 -535 0 -535 0 0 850 0 850 535 0 535 0 0 -850z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 7895 l0 -1065 855 0 855 0 0 1065 0 1065 -855 0 -855 0 0 -1065z m1280 -5 l0 -640 -425 0 -425 0 0 640 0 640 425 0 425 0 0 -640z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3420 7895 l0 -1065 850 0 850 0 0 1065 0 1065 -850 0 -850 0 0 -1065z m1280 -5 l0 -640 -430 0 -430 0 0 640 0 640 430 0 430 0 0 -640z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5550 7895 l0 -1065 855 0 855 0 0 1065 0 1065 -855 0 -855 0 0 -1065z m1280 -5 l0 -640 -425 0 -425 0 0 640 0 640 425 0 425 0 0 -640z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 4905 l0 -1065 855 0 855 0 0 1065 0 1065 -855 0 -855 0 0 -1065z m1280 5 l0 -640 -425 0 -425 0 0 640 0 640 425 0 425 0 0 -640z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3420 4905 l0 -1065 850 0 850 0 0 1065 0 1065 -850 0 -850 0 0 -1065z m1280 5 l0 -640 -430 0 -430 0 0 640 0 640 430 0 430 0 0 -640z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5550 4905 l0 -1065 855 0 855 0 0 1065 0 1065 -855 0 -855 0 0 -1065z m1280 5 l0 -640 -425 0 -425 0 0 640 0 640 425 0 425 0 0 -640z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondo);
export default __webpack_public_path__ + "static/media/condo.e02f941df5d11925d44f6e729c40ca72.svg";
export { ForwardRef as ReactComponent };